import { useState } from 'react'
import { Plus } from 'lucide-react'
import { Button, Chip, Input, toast } from '@/components/ui'
import {
  useCreateShippingDocType,
  useShippingDocTypes,
  useUpdateShippingDocType,
} from '../api/shipping-docs-queries'

/** Admin: shipping document types are data; new ones appear in the upload
 *  picker and the Odoo wizard without a code change. Deactivate, never delete. */
export function ShippingDocTypesPanel() {
  const { data = [] } = useShippingDocTypes(true)
  const create = useCreateShippingDocType()
  const update = useUpdateShippingDocType()
  const [label, setLabel] = useState('')

  const add = () => {
    const name = label.trim()
    if (!name) return
    const key = name.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '')
    create.mutate(
      { key: /^[a-z]/.test(key) ? key : `t_${key}`, label: name },
      {
        onSuccess: () => {
          toast.success(`${name} added`)
          setLabel('')
        },
        onError: (err) => toast.danger('Could not add type', { description: (err as Error).message }),
      },
    )
  }

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-wrap gap-2">
        {data.map((t) => (
          <button
            key={t.key}
            type="button"
            title={t.active ? 'Click to deactivate' : 'Click to reactivate'}
            onClick={() => update.mutate({ key: t.key, body: { active: !t.active } })}
          >
            <Chip variant={t.active ? 'neutral' : 'warning'}>
              {t.label}
              {t.active ? '' : ' (inactive)'}
            </Chip>
          </button>
        ))}
      </div>
      <div className="flex gap-2">
        <Input aria-label="New type name" value={label} placeholder="New document type" onChange={(e) => setLabel(e.target.value)} />
        <Button variant="secondary" size="sm" onClick={add} loading={create.isPending} disabled={!label.trim()}>
          <Plus size={14} /> Add type
        </Button>
      </div>
    </div>
  )
}
